import axios from 'axios';

import { sleep } from '~/utils';
import { flattenData } from '~/helpers/journal';
import urls from '~/urls';

import bblxUrls from './urls';
import { Sound, Sounds, Beat } from './models';
import { MIME_TYPES } from './constants/media';
import B from './assets/b-kick.flac';
import t from './assets/t-hi-hat.flac';
import k from './assets/k-snare.flac';
import Pf from './assets/pf-snare.flac';
import rw from './assets/recorder-whistle.flac';
import d from './assets/dry-kick.flac';
import iOD from './assets/inward-od-bass.flac';
import Ts from './assets/open-hi-hat.flac';
import BMG from './assets/spit-snare.flac';
import G from './assets/throat-kick.flac';
import Bs from './assets/bs-kick.flac';
import f from './assets/f-hi-hat.flac';
import K1 from './assets/outward-k-snare.flac';
import Psh from './assets/psh-snare.flac';
import hut from './assets/sucker-punch.flac';
import c from './assets/tongue-click.flac';
import df from './assets/df-hi-hat.flac';
import K from './assets/inward-k-snare.flac';
import KIM from './assets/kim-squeak.flac';
import Peh from './assets/peh-snare.flac';
import ib from './assets/inward-bass.flac';
import d1 from './assets/d-kick.flac';
import hcp from './assets/hollow-clop.flac';
import hilr from './assets/hollow-inward-liproll.flac';
import hub from './assets/hut-percussion.flac';
import B1 from './assets/inward-kick.flac';
import k1 from './assets/k-percussion.flac';
import lrs from './assets/liproll-scratch.flac';
import mg from './assets/machine-gun-percussion.flac';
import B2 from './assets/outward-subbass-kick.flac';
import osb from './assets/outward-subbass.flac';
import dk from './assets/duck-sound.flac';
import icr from './assets/inward-click-roll.flac';
import ks from './assets/kiss.flac';
import lr from './assets/liproll.flac';
import stb from './assets/sharp-tongue-bass.flac';
import slr from './assets/subbass-liproll.flac';
import A from './assets/cough-snare.flac';
import nA from './assets/nose-cough-snare.flac';
import FBMG from './assets/footboxg-bmg.flac';
import zb from './assets/zombie-bass.flac';
import ts from './assets/sucking-hi-hat.flac';
import wub from './assets/wub.flac';
import bwub from './assets/bubble-wub.flac';
import hwub from './assets/hollow-wub.flac';
import c2 from './assets/top-down-click.flac';
import cp from './assets/clop.flac';
import pop from './assets/pop.flac';
import hpop from './assets/hollow-pop.flac';
import lsmk from './assets/lip-smack.flac';
import lb from './assets/lip-bass.flac';
import lbub from './assets/lip-bubble.flac';
import lhs from './assets/lip-hiss.flac';
import thb from './assets/throat-bass.flac';
import vcb from './assets/vocalized-chest-bass.flac';
import tr from './assets/tongue-roll.flac';
import OD from './assets/od-bass.flac';
import trp from './assets/trumpet.flac';
import dv from './assets/double-voice.flac';
import itw from './assets/inward-tooth-whistle.flac';
import lz from './assets/lip-zipper.flac';
import ohk from './assets/ohk-sound.flac';
import Poh from './assets/poh-snare.flac';
import rPoh from './assets/reverse-poh.flac';
import Bsh from './assets/bsh-snare.flac';
import THK from './assets/two.h-subbass-snare.flac';

const getSound = (
  id: number,
  name: string,
  notation: string,
  url: string
): Sound => ({
  id,
  name,
  notation,
  sample: {
    id,
    recording: {
      mime: MIME_TYPES.flac,
      url,
    },
  },
});

// TODO: actually get data from backend
export const readSounds = async (): Promise<Sounds> => {
  await sleep(500);

  return [
    getSound(0, 'B kick', 'B', B),
    getSound(1, 't hi-hat', 't', t),
    getSound(2, 'k rimshot', 'k', k),
    getSound(3, 'Pf snare', 'Pf', Pf),
    getSound(4, 'recorder whistle', 'rw', rw),
    getSound(5, 'dry kick', 'd', d),
    getSound(6, 'inward OD bass', 'iOD', iOD),
    getSound(7, 'open hi-hat', 'Ts', Ts),
    getSound(8, 'spit snare', 'BMG', BMG),
    getSound(9, 'throat kick', 'G', G),
    getSound(10, 'Bs kick', 'Bs', Bs),
    getSound(11, 'f hi-hat', 'f', f),
    getSound(12, 'outward K snare', 'K1', K1),
    getSound(13, 'Psh snare', 'Psh', Psh),
    getSound(14, 'sucker punch', 'hut', hut),
    getSound(15, 'tongue click', 'c', c),
    getSound(16, 'df hi-hat', 'df', df),
    getSound(17, 'inward K snare', 'K', K),
    getSound(18, 'KIM squeak', 'KIM', KIM),
    getSound(19, 'Peh snare', 'Peh', Peh),
    getSound(20, 'inward bass', 'ib', ib),
    getSound(21, 'd kick', 'd1', d1),
    getSound(22, 'hollow clop', 'hcp', hcp),
    getSound(23, 'hollow inward lip roll', 'hilr', hilr),
    getSound(24, 'lip sucker punch', 'hub', hub),
    getSound(25, 'inward kick', 'B1', B1),
    getSound(26, 'k percussion', 'k1', k1),
    getSound(27, 'lip roll scratch', 'lrs', lrs),
    getSound(28, 'machine gun', 'mg', mg),
    getSound(29, 'outward subbass kick', 'B2', B2),
    getSound(30, 'outward subbass', 'osb', osb),
    getSound(31, 'duck sound', 'dk', dk),
    getSound(32, 'inward click roll', 'icr', icr),
    getSound(33, 'kiss', 'ks', ks),
    getSound(34, 'lip roll', 'lr', lr),
    getSound(35, 'sharp tongue bass', 'stb', stb),
    getSound(36, 'subbass lip roll', 'slr', slr),
    getSound(37, 'cough snare', 'A', A),
    getSound(38, 'nasal cough snare', 'nA', nA),
    getSound(39, 'FootboxG spit snare', 'FBMG', FBMG),
    getSound(40, 'zombie bass', 'zb', zb),
    getSound(41, 'sucking hi-hat', 'ts', ts),
    getSound(42, 'wub', 'wub', wub),
    getSound(43, 'bubble wub', 'bwub', bwub),
    getSound(44, 'hollow wub', 'hwub', hwub),
    getSound(45, 'top-down click', 'c2', c2),
    getSound(46, 'clop', 'cp', cp),
    getSound(47, 'pop', 'pop', pop),
    getSound(48, 'hollow pop', 'hpop', hpop),
    getSound(49, 'lip smack', 'lsmk', lsmk),
    getSound(50, 'lip bass', 'lb', lb),
    getSound(51, 'lip bubble', 'lbub', lbub),
    getSound(52, 'lip hiss', 'lhs', lhs),
    getSound(53, 'throat bass', 'thb', thb),
    getSound(54, 'vocalized chest bass', 'vcb', vcb),
    getSound(55, 'tongue roll', 'tr', tr),
    getSound(56, 'OD bass', 'OD', OD),
    getSound(57, 'trumpet', 'trp', trp),
    getSound(58, 'double voice', 'dv', dv),
    getSound(59, 'inward tooth whistle', 'itw', itw),
    getSound(60, 'lip zipper', 'lz', lz),
    getSound(61, 'ohk sound', 'ohk', ohk),
    getSound(62, 'Poh snare', 'Poh', Poh),
    getSound(63, 'reverse Poh', 'rPoh', rPoh),
    getSound(64, 'Bsh snare', 'Bsh', Bsh),
    getSound(65, 'Two.H subbass snare', 'THK', THK),
  ];
};

// Beat
export const createBeat = async (beat: Beat): Promise<string> => {
  const response = await axios.post(bblxUrls.beats, beat);

  return response.data.data.attributes.code;
};

export const readBeat = async (code: string): Promise<Beat> => {
  const response = await axios.get(bblxUrls.beat(code));
  const beat: Beat = flattenData(response.data.data);

  return beat;
};

export const deleteBeat = async (code: string): Promise<string> => {
  const response = await axios.delete(bblxUrls.beat(code));

  return response.data.data.attributes.code;
};

export const readRecording = async (
  url: string,
  type: string
): Promise<Blob> => {
  const finalUrl = url.startsWith('/') ? `${urls.base}/${url.slice(1)}` : url;
  const response = await axios.get(finalUrl, { responseType: 'arraybuffer' });

  return new Blob([response.data], { type });
};
